import { render } from "./avatarCropper.vue?vue&type=template&id=161a26a0&scoped=true&ts=true"
import script from "./avatarCropper.vue?vue&type=script&lang=ts"
export * from "./avatarCropper.vue?vue&type=script&lang=ts"

import "./avatarCropper.vue?vue&type=style&index=0&id=161a26a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161a26a0"]])

export default __exports__